import { render, staticRenderFns } from "./BotaoRastreabilidade.vue?vue&type=template&id=596072ec&lang=pug"
import script from "./BotaoRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BotaoRastreabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports